import { formatCurrency, formatNumber } from 'ddc-intl';
import { showAsCashOffer } from './incentives';

export const getPaymentLabel = (incentive = {}, payment = {}) => {
	const type = payment?.paymentLabel?.toLowerCase();
	const { paymentTerm, apr, downPayment, annualMiles } = payment;

	if (showAsCashOffer(incentive)) {
		const cash =
			incentive?.cash ||
			incentive?.termRebates?.incentiveTermRange?.[0]?.customerCash;
		return `${formatCurrency(cash)} cash back`;
	}

	if (
		type === 'finance' &&
		paymentTerm &&
		apr &&
		!Number.isNaN(downPayment)
	) {
		return `${paymentTerm} mo, ${apr}% APR, ${formatCurrency(
			downPayment
		)} down`;
	}

	if (
		type === 'lease' &&
		paymentTerm &&
		annualMiles &&
		!Number.isNaN(downPayment)
	) {
		return `${paymentTerm} mo, ${formatNumber(
			annualMiles
		)} mi/yr, ${formatCurrency(downPayment)} down`;
	}

	if (type === 'finance' || type === 'lease') {
		return type === 'finance' ? 'Finance Offer' : 'Lease Offer';
	}

	return null;
};

export const getPaymentPrefix = ({ paymentLabel }) => {
	if (paymentLabel?.toLowerCase() === 'cash') {
		return 'Cash Terms';
	}

	if (paymentLabel?.toLowerCase() === 'finance') {
		return 'Finance Terms';
	}

	if (paymentLabel?.toLowerCase() === 'lease') {
		return 'Lease Terms';
	}

	return 'Terms';
};
